module.exports = __webpack_public_path__ + "img/ic_32_profile_fragen_antworten.ec85f6ac.svg";